





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCamaraModulo } from '@/pantallas/Camaras/fetchCamaraModulos';
import { LoadingService } from '@/services/loadingService';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';


@Component({
  components: {},
})
export default class InLiveCams extends Vue {
  @Prop({ default: {} }) current_patent: any;
  @Prop({ default: (): [] => [] }) listCam!: any[];
  @Prop() emptyPatent: boolean;
  @Prop({default: 5})  limitAncientCams: number;
  @Prop({default: {}}) configVss: any;
  sockets: WebSocket[] = [];
  listCamCms6: any[] = [];
  listCamMounted: any[] = [];
  listCamCeiba: any[] = [];
  listCamNuevo: any[] = [];
  listCamHowenVss: {ind: number, val: any}[] = [];
  listWindowVss: any = {};
  listCamFill: any[] = [];
  videoVss: any = null;
  loadingService = new LoadingService();
  ttxVideoAll: any;
  swfobject: any;
  listStreamaxMounted: any[] = [];
  $snotify: any;
  intervalLavaPlayer: any = null;
  mounted() {
    var self = this;
    setTimeout(() => {
      this.initializeHowenVss();
      self.valideJSScript(0);
    }, 3000);
    //this.initializeHowenVss();
  }
  valideJSScript(count: number) {
    var self = this;
    if (document.getElementById('camContainerLiveAncient')) {
      if (count == 0) {
        this.loadingService.showLoading('Por favor espere...', 'inliveCam');
      }
      // @ts-ignore
      if (!window.lavaPlayer || !window.liveplay) {
        console.log(
          '[Error] Los scripts de Lavaplayer no cargaron correctamente; se recargarán'
        );
        this.loadJSScript();
        setTimeout(() => {
          self.valideJSScript(count + 1);
        }, 3000);
        if (count == 5) {
          this.loadingService.hideLoading('inliveCam');
          this.$snotify.error(
            'Hubo un error al cargar el visualizador Ceiba, inténtelo de nuevo más tarde...'
          );
        }
      } else {
        console.log('[OK] Lavaplayer');
        try{
          this.initStreamaxVideo();
        }catch(e){
          console.log(e);
        }
        this.loadingService.hideLoading('inliveCam');
      }
    }
  }
  loadJSScript() {
    var head = document.getElementsByTagName('head')[0];

    // Se borra el script 1
    document.getElementById('lava-player-1').remove();
    var lavaplayer1: HTMLLinkElement = document.createElement('link');
    lavaplayer1.id = 'lava-player-1';
    lavaplayer1.rel = 'stylesheet';
    lavaplayer1.href =
      'https://live.gpschile.com/ms/js_css/player/style/lava-player.css';
    // Se recarga el script 1
    head.appendChild(lavaplayer1);

    // Se borra el script 2
    document.getElementById('lava-player-2').remove();
    var lavaplayer2: HTMLScriptElement = document.createElement('script');
    lavaplayer2.id = 'lava-player-2';
    lavaplayer2.type = 'text/javascript';
    lavaplayer2.src =
      'https://live.gpschile.com/ms/js_css/player/js/jquery.lava-videolayout.js';
    // Se recarga el script 2
    head.appendChild(lavaplayer2);

    // Se borra el script 3
    document.getElementById('lava-player-3').remove();
    var lavaplayer3: HTMLScriptElement = document.createElement('script');
    lavaplayer3.id = 'lava-player-3';
    lavaplayer3.type = 'text/javascript';
    lavaplayer3.src =
      'https://live.gpschile.com/ms/js_css/player/js/flv20170504.min.js';
    // Se recarga el script 3
    head.appendChild(lavaplayer3);

    // Se borra el script 4
    document.getElementById('lava-player-4').remove();
    var lavaplayer4: HTMLScriptElement = document.createElement('script');
    lavaplayer4.id = 'lava-player-4';
    lavaplayer4.type = 'text/javascript';
    lavaplayer4.src = 'https://live.gpschile.com/ms/js_css/player/js/lang.js';
    // Se recarga el script 4
    head.appendChild(lavaplayer4);

    // Se borra el script 5
    document.getElementById('lava-player-5').remove();
    var lavaplayer5: HTMLScriptElement = document.createElement('script');
    lavaplayer5.id = 'lava-player-5';
    lavaplayer5.type = 'text/javascript';
    lavaplayer5.src =
      'https://live.gpschile.com/ms/js_css/player/js/lava-player.js';
    // Se recarga el script 5
    head.appendChild(lavaplayer5);
  }

  initializeHowenVss(){
    console.log("[INITIALIZE] HOWEN VSS")
    let idEle: string = "#test"; // id player
    let winCount: string = "4"; // número de ventanas del player
    let showTool: boolean = true; // Barra de herramientas de acciones
    let openSound: boolean = false; // Sonido
    let showControl: boolean = true; // Barra de acciones en la ventana
    // @ts-ignore
    this.videoVss= new HowenVideoPlayer(idEle, parseInt(winCount), showTool, openSound, showControl);

    for(let i = 0 ; i < 16 ; i++){
      this.listWindowVss[i] = null;
    }

    try{
      this.videoVss.setToken(this.configVss.token);
    }catch(e){
      console.log(e);
    }

    // console.log(this.listWindowVss);

    // let serverip: string = "http://howen2.gpschile.com:33122"; // Ip server howen
    // let deviceid: string = "2022111704"; // Id cámara
    // let chl: string = "2"; // Canal cámara
    // let chlName: string = "CH1"; // Nombre canal
    // let mainStream: string = "1"; // Stream 
    // // @ts-ignore
    // this.videoVss.playVideo(serverip, deviceid, chl, chlName, mainStream)
  }

  @Watch('configVss', {immediate: true})
  onConfigChange(){
    if(Object.keys(this.configVss).length !== 0){
      console.log("Carga token vss");
      console.log(this.configVss)
      try{
        this.videoVss.setToken(this.configVss.token);
      }catch(e){
        console.log(e);
      }
    }
  }

  async created() {
    var self = this;
    window.addEventListener('resize', () => {
      setTimeout(() => {
        self.resize();
      }, 500);
    });
    CamaraEventBus.$on('refreshCam', () => {
      setTimeout(() => {
        self.resize();
      }, 500);
    });
    CamaraEventBus.$on('handleCams', async (cams: any, action: string) => {  // Se selecciona o deselecciona una cámara
      console.log('Action -> [' + action + ']');
      ///////////////////////////////////////////////////////////////////////////////
      if (action == 'insert') {
        for (let key in cams) {
          let index = this.searchCam(cams[key]);
          if (index == -1) {
            await this.insertCam(cams[key]);
          }
        }
        let handleCms6 = cams.findIndex((channel: any) => channel.tipo_live.toLowerCase() == 'antiguo');
        // Validación para reinsertar todas las cámaras de nuevo
        if (handleCms6 != -1) {
          setTimeout(() => {
            this.cms6Cam();
          }, 500);
        }
      ////////////////////////////////////////////////////////////////////////////////
      } else if (action == 'remove') {
        for (var key in cams) {
          let index = this.searchCam(cams[key]);
          if (index != -1) {
            this.removeCam(cams[key], index);
          }
        }
        if (this.listCam.length == 0) {
          this.listCamFill = [];
        }
        if (this.listCamCeiba.length == 0) {
          clearInterval(this.intervalLavaPlayer);
        }
        let handleCms6 = cams.findIndex((channel: any) => channel.tipo_live.toLowerCase() == 'antiguo');
        // Validación para reinsertar todas las cámaras de nuevo
        if (handleCms6 != -1) {
          this.closeConnect();
          setTimeout(() => {
            this.cms6Cam();
          }, 500);
        }
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      } else if (action == 'clear') {
        for (var index in this.sockets) {
          this.sockets[index].onclose = function() {};
          this.sockets[index].close();
        }
        this.sockets = [];
        this.listCamMounted = [];
        this.listStreamaxMounted = [];
        this.listCamFill = [];
        this.listCamCeiba = [];
        this.listCamNuevo = [];
        this.listCamCms6 = [];
        this.listCamHowenVss = [];
        for(let i = 0 ; i < 16 ; i++){
        this.listWindowVss[i] = null;
      }
        clearInterval(this.intervalLavaPlayer);
        try {
          // @ts-ignore
          $('#div_video').lavaPlayer('clearAll');
        } catch (e) {
          console.log('No existe método clearAll');
        }
        this.closeConnect();
      }

      //  Redimensionar visualizadores
      this.visualizersResize();

    });
  }

  beforeDestroy() {
    setTimeout(() => {
      CamaraEventBus.$off('refreshCam');
      CamaraEventBus.$off('resize');
      CamaraEventBus.$off('handleCams');
    }, 1000);
  }


  findAvailableCamVss(): any{
    for(let index in this.listWindowVss){
      console.log("WindowVss-> ",this.listWindowVss[index]);
      if(this.listWindowVss[parseInt(index)] == null){
        return parseInt(index);
      };
    }
    return -1;
  }

  visualizersResize(){
    const validation = (this.listCamCeiba.length != 0).toString() +"|"+ (this.listCamCms6.length != 0).toString() +"|"+ (this.listCamNuevo.length != 0 || this.listCamHowenVss.length != 0).toString();
    switch(validation){
      case 'true|true|true':
        document.getElementById('div_video').style.height = '65%';
        document.getElementById('camContainerLiveAncient').style.height = '65%';
        document.getElementById('gridCams').style.height = '65%';
        document.getElementById('test').style.height = '65%';
        this.refreshVss();
        break;
      case 'true|true|false':
        document.getElementById('div_video').style.height = '65%';
        document.getElementById('camContainerLiveAncient').style.height = '65%';
        document.getElementById('gridCams').style.height = '100%';
        document.getElementById('test').style.height = '100%';
        // Resize para el visualizador cms6
        this.resize();
        break;
      case 'false|true|true':
        document.getElementById('div_video').style.height = '100%';
        document.getElementById('camContainerLiveAncient').style.height = '65%';
        document.getElementById('gridCams').style.height = '65%';
        document.getElementById('test').style.height = '65%';
        this.refreshVss();
        // Resize para el visualizador cms6
        this.resize();
        break;
      case 'true|false|true':
        document.getElementById('div_video').style.height = '65%';
        document.getElementById('camContainerLiveAncient').style.height = '100%';
        document.getElementById('gridCams').style.height = '65%';
        document.getElementById('test').style.height = '65%';
        this.refreshVss();
        break;
      case 'false|false|true':
        document.getElementById('div_video').style.height = '100%';
        document.getElementById('camContainerLiveAncient').style.height = '100%';
        document.getElementById('gridCams').style.height = (this.listCamHowenVss.length != 0? '65%' : '100%');
        document.getElementById('test').style.height = (this.listCamNuevo.length != 0? '65%' : '100%');
        this.refreshVss();
        break;
      default:
        document.getElementById('div_video').style.height = '100%';
        document.getElementById('camContainerLiveAncient').style.height = '100%';
        document.getElementById('gridCams').style.height = '100%';
        document.getElementById('test').style.height = '100%';
        // Resize para el visualizador cms6
        this.resize();
        this.refreshVss();
        break;

    }
  }
  
  playStreamaxVideo(chl: any) {
    let index: number = this.getEmptyVideo();
    // @ts-ignore
    var video = $('video')[index];
    var url = chl.url_live;
    // @ts-ignore
    liveplay(video, url);
    this.listStreamaxMounted.push({
      id: chl.patent + '-' + chl.name + '-' + chl.id,
      index: index,
    });
    // @ts-ignore
    $('#div_video').lavaPlayer('addVideo', {
      url: url,
      title: chl.patent + '-' + chl.id_camara + '-' + chl.name,
    });
  }

  closeStreamaxVideo(index: any) {
    try {
      //@ts-ignore
      $('#div_video').lavaPlayer('clearVideo', $('video')[index]);
    } catch (e) {
      console.log('No existe método clearVideo');
    }
  }

  searchStreamaxCam(chl: any): { indexFrom: number; indexTo: number } {
    for (let i = 0; i < this.listStreamaxMounted.length; i++) {
      if (
        this.listStreamaxMounted[i].id ==
        chl.patent + '-' + chl.name + '-' + chl.id
      ) {
        return { indexFrom: i, indexTo: this.listStreamaxMounted[i].index };
      }
    }
    return { indexFrom: -1, indexTo: -1 };
  }

  getEmptyVideo(): number {
    let index: number;
    // @ts-ignore
    for (let i = 0; i < $('video').length; i++) {
      // @ts-ignore

      if (Object.keys($('video')[i]).length == 0) {
        return i;
      } else {
        // @ts-ignore
        for (var video of Object.keys($('video')[i])) {
          // @ts-ignore
          if (video.toLowerCase().includes('jquery')) {
            // @ts-ignore
            if ($('video')[i][video] == undefined) {
              return i;
            }
          }
        }
      }
    }
    return -1;
  }

  initStreamaxVideo() {
    console.log('[InitGridVideoPlayer]');
    // @ts-ignore
    $('#div_video').lavaPlayer({
      playType: 'html5',
      layoutNum: 4,
      streamToggle: true,
      onReady: function() {},
    });
  }

  parse(data: any) {
    var input = new Uint8Array(data),
      dv = new DataView(input.buffer),
      duration,
      audioLength,
      audio,
      video;

    duration = dv.getUint16(0, true);
    //audioLength = dv.getUint16(2, true);
    //audio = input.subarray(4, (audioLength + 4));
    // @ts-ignore
    video = input.subarray(audioLength + 4);
    //alert(duration);
    return {
      //audio: audio,
      video: video,
      duration: duration,
    };
  }

  searchCam(chl: any): number {
    var index: number;
    switch(chl.tipo_live.toLowerCase()){
      case 'ceiba2':  // Streamax
        index = this.listCamCeiba.findIndex(
          (channel: any) => channel.id == chl.id
        );
        break;
      case 'nuevo':  // Howen nuevas
        index = this.listCamNuevo.findIndex(
          (channel: any) => channel.id == chl.id
        );
        break;    // Howen antiguas
      case 'antiguo':
        index = this.listCamCms6.findIndex(
          (channel: any) => channel.id == chl.id
        );
        break;
        case 'howen_vss':
        index = this.listCamHowenVss.findIndex(
          (channel: any) => channel.val.id == chl.id
        );
        break;
    }
    return index;
  }

  removeCam(chl: any, index: any) {
    let self = this;
    switch(chl.tipo_live.toLowerCase()){
      case 'ceiba2':  // Streamax
        var indexS: {
          indexFrom: number;
          indexTo: number;
        } = this.searchStreamaxCam(chl);
        this.closeStreamaxVideo(indexS.indexTo);
        this.listCamCeiba.splice(index, 1);
        this.listStreamaxMounted.splice(indexS.indexFrom, 1);
        break;
      case 'nuevo':  // Howen nuevas
        this.sockets[chl.positionArray].onclose = function() {};
        this.sockets[chl.positionArray].close();
        this.listCamNuevo.splice(index, 1);
        this.proccessList();
        break;    // Howen antiguas
      case 'antiguo':
        this.listCamCms6.splice(index, 1);
        break;
      case 'howen_vss':
        this.videoVss.stop(this.listCamHowenVss[index].ind);
        this.unloadVss(this.listCamHowenVss[index].ind);
        this.listWindowVss[this.listCamHowenVss[index].ind] = null;
        this.listCamHowenVss.splice(index, 1);
        break;
    }
  }

  refreshVss(){
    try{
      let div = document.querySelector('div[data-index="0"]');

      var eventoClick = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': true
      });

      div.dispatchEvent(eventoClick);
    }
    catch(e){
      console.log(e);
    }
  }


  unloadVss(index: number){
    let container = document.querySelector('div[data-index="'+index+'"]');
    container = container.querySelector('div[data-index="'+index+'"]');
    //@ts-ignore
    container.style.background = "url(image/logo2.png) no-repeat center center";
    
    let label = document.querySelector('.tv_video_item_box_ch');
    label.innerHTML = '';
  }

  async insertCam(chl: any) {
    var self = this;
    //this.listCamMounted.push(chl);
    switch(chl.tipo_live.toLowerCase()){
      case 'ceiba2':  // Streamax
        this.listCamCeiba.push(chl);
        clearInterval(this.intervalLavaPlayer);
        this.intervalLavaPlayer = setInterval(() => {
          console.log('[Se reinicia timeout player]');
          // @ts-ignore
          $('#div_video').lavaPlayer('setTimeout');
          
        }, 50000);

        setTimeout(() => {
          self.resizeLayoutLavaPlaver(this.listCamCeiba.length);
          self.playStreamaxVideo(chl);
        }, 500);
        break;
      case 'nuevo':  // Howen nuevas
        this.listCamNuevo.push(chl);
        this.proccessList();
        setTimeout(() => {
          self.loadWsCams(chl);
        }, 200);
        break;    // Howen antiguas
      case 'antiguo':
        this.listCamCms6.push(chl);
        break;
      case 'howen_vss':
        let index = await this.findAvailableCamVss();
        this.listWindowVss[index] = chl;
        this.listCamHowenVss.push({ind: index, val: chl});
        this.loadVss(chl)
        break;
    }

  }


  loadVss(chl: any){
    let serverip: string = this.configVss.server_ip; // Ip server howen
    let deviceid: string = chl.id_camara; // Id cámara
    // let deviceid: string = chl.id_camara; // Id cámara
    let channel: string = chl.name; // Canal cámara
    let chlName: string = "CH"+chl.name; // Nombre canal
    let mainStream: string = this.configVss.main_stream; // Stream 
    // @ts-ignore
    this.videoVss.playVideo(serverip, deviceid, channel, chlName, mainStream)
  }

  resizeLayoutLavaPlaver(sizeCams: number) {
    if (sizeCams <= 4) {
      // @ts-ignore
      $('#div_video').lavaPlayer('setLayout', 4);
    } else if (sizeCams <= 6) {
      // @ts-ignore
      $('#div_video').lavaPlayer('setLayout', 6);
    } else if (sizeCams <= 9) {
      // @ts-ignore
      $('#div_video').lavaPlayer('setLayout', 9);
    } else if (sizeCams <= 16) {
      // @ts-ignore
      $('#div_video').lavaPlayer('setLayout', 16);
    }
  }

  cms6Cam() {
    let self = this;
    this.closeConnect();
    // @ts-ignore
    if (typeof swfobject == 'undefined' || swfobject.getObjectById('cmsv6flash') == null || typeof swfobject.getObjectById('cmsv6flash').setWindowNum == 'undefined') {
      console.log("[Init] se inicializa el visualizador Cms6")
      this.initCms6Grid();
    }
    setTimeout(() => {
      console.log("Ejecutando initFlash")
      self.initFlash();
    }, 200);
    //this.initFlash(chl);
  }

  loadWsCams(chl: any) {
    var socketURL =
      'wss://live.gpschile.com/wss/' +
      chl.id_camara +
      '/' +
      chl.name +
      '/' +
      chl.tstr;
    // @ts-ignore
    var jmuxer = new JMuxer({
      node: 'playerVideo' + chl.id,
      mode: 'video',
      // @ts-ignore
      fps: 30,
      // @ts-ignore
      readFpsFromTrack: false,
      // @ts-ignore
      clearBuffer: false,
      debug: true,
    });
    // @ts-ignore
    console.log(
      '[Aviso] Se genera la conexión con la cámara ' +
        chl.patent +
        ' canal ' +
        chl.name +
        '.'
    );
    var ws = new WebSocket(socketURL);
    this.sockets.push(ws);
    chl.positionArray = this.sockets.length - 1;
    ws.binaryType = 'arraybuffer';
    var self = this;
    chl.dataReceived = 0;
    ws.addEventListener('message', function(event) {
      // @ts-ignore
      var data = self.parse(event.data);
      jmuxer.feed(data);
      chl.dataReceived += 1;
    });
    setTimeout(() => {
      self.valideReconnect(chl, 0);
    }, chl.timeout * 60000);
  }

  valideReconnect(chl: any, totalData: number) {
    const currentTime: Date = new Date();
    const time: string =
      currentTime.getHours() +
      ':' +
      (currentTime.getMinutes() < 10 ? '0' : '') +
      currentTime.getMinutes() +
      ':' +
      (currentTime.getSeconds() < 10 ? '0' : '') +
      currentTime.getSeconds();
    if (chl.dataReceived > totalData) {
      var newData: number = chl.dataReceived + 0;
      console.log(
        '[Aviso] La cámara ' +
          chl.patent +
          ' canal ' +
          chl.name +
          ' ha enviado paquetes en los últimos ' +
          chl.timeout +
          ' minutos || hora: ' +
          time
      );
      var self = this;
      setTimeout(() => {
        self.valideReconnect(chl, newData);
      }, chl.timeout * 60000);
      return;
    } else {
      console.log(
        '[Aviso] La cámara ' +
          chl.patent +
          ' canal ' +
          chl.name +
          ' no ha enviado paquetes en los últimos ' +
          chl.timeout +
          ' minutos; Se reinicia la conexión || hora: ' +
          time
      );
      this.sockets[chl.positionArray].onclose = function() {};
      this.sockets[chl.positionArray].close();
      this.loadWsCams(chl);
    }
  }

  destroyed() {
    var self = this;
    window.removeEventListener('resize', () => {
      setTimeout(() => {
        self.resize();
      }, 500);
    });
    this.closeConnect();
  }

  resize() {
    var width = document.getElementById('camContainerLiveAncient').offsetWidth - 5;
    var height = document.getElementById('camContainerLiveAncient').offsetHeight - 5;
    document.getElementById('cmsv6flash').style.width = width.toString() + 'px';
    document.getElementById('cmsv6flash').style.height =
      height.toString() + 'px';
  }

  initCms6Grid() {
    console.log('[Aviso] Se carga la grilla Cms6');
    var params = { lang: 'en' };
    var camContainer = document.getElementById('camContainerLiveAncient');
    // @ts-ignore
    ttxVideoAll.init(
      'cmsv6flash',
      [...Array(5).keys()],
      camContainer.getBoundingClientRect().width,
      camContainer.getBoundingClientRect().height,
      params,
      'auto'
    );
  }

  closeConnect() {
    try {
      for (var i = 0; i < 20; i++) {
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').stopVideo(i);
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').reSetVideo(i);
      }
      // @ts-ignore
    } catch (error) {
      console.log(null);
    }
  }

  //Are video plug loading complete
  initFlash() {
    if (
      // @ts-ignore
      typeof swfobject == 'undefined' ||
      // @ts-ignore
      swfobject.getObjectById('cmsv6flash') == null ||
      // @ts-ignore
      typeof swfobject.getObjectById('cmsv6flash').setWindowNum == 'undefined'
    ) {
      console.log("Entró en if!!");
      var self = this;
      setTimeout(() => {
        self.initFlash();
      }, 50);
    } else {
      var size: number = this.listCamCms6.length;

      if (size <= 4) {
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').setWindowNum(4);
      } else if(size <= 9) {
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').setWindowNum(9);
      } else if(size <= 16) {
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').setWindowNum(16);
      } else{
        // @ts-ignore
        swfobject.getObjectById('cmsv6flash').setWindowNum(size);
      }
      // if (this.listCamCms6.length == 0) {
      //   // @ts-ignore
      //   swfobject
      //     .getObjectById('cmsv6flash')
      //     .setServerInfo('cms6.gpschile.com', '6605');
      // }
      // @ts-ignore
      swfobject
          .getObjectById('cmsv6flash')
          .setServerInfo('cms6.gpschile.com', '6605');

      for (var [index, channel] of this.listCamCms6.entries()) {
        // @ts-ignore
        swfobject
          .getObjectById('cmsv6flash')
          .startVideo(
            index,
            '6b16377be0c142a8988fa030e84932d4',
            channel.id_camara,
            (parseInt(channel.name) - 1).toString(),
            1,
            true
          );
        // @ts-ignore
        swfobject
          .getObjectById('cmsv6flash')
          .setVideoInfo(index, channel.patent + '-CH' + channel.name);
      }
      this.resize();
      //this.listCamCms6 = JSON.parse(JSON.stringify(this.listCamMounted));
    }
  }

  async proccessList() {
    var self = this;
    if (this.listCamNuevo.length == 0) {
      this.listCamFill = [];
    } else {
      this.listCamFill = JSON.parse(JSON.stringify(this.listCamNuevo));
    }
    var size: number = this.listCamNuevo.length;
    if (size > 0) {
      this.valideSizeNewCams();
      this.listCamNuevo.sort((x: any, y: any) => {
        return x.background - y.background;
      });
    }
  }

  fillbackground(total: number) {
    var difference: number = total - this.listCamNuevo.length;

    for (var i = 0; i < difference; i++) {
      this.listCamFill.push({ background: true });
    }
  }

  valideSizeNewCams() {
    var size: number = this.listCamNuevo.length;
    if (size <= 4) {
      document.getElementById('gridCams').style.gridTemplateColumns = '50% 50%';
      document.getElementById('gridCams').style.gridTemplateRows = '50% 50%';
      this.fillbackground(4);
    } else {
      var css = '';
      let x = Math.ceil(Math.sqrt(size));
      for (let i = 0; i < x; i++) {
        css += ' ' + 100 / x + '%';
      }
      this.fillbackground(x * x);
      document.getElementById('gridCams').style.gridTemplateColumns = css;
      document.getElementById('gridCams').style.gridTemplateRows = css;
    }
  }
}
